// extracted by mini-css-extract-plugin
module.exports = {"send__icon":"ChatInput_send__icon__3tCRu","input":"ChatInput_input__3jf0l","input__block":"ChatInput_input__block__1HhaW","submit":"ChatInput_submit__3G8QO"};